/**
 * Fahrzeug-Stellplätze pro Immobilie (NT-VIERTEL-FIX-01, V1) — Typen + Abruf, geteilt von Markt
 * (Kauf-Ziel), Lagerhaus (Garage) und Crime Ops (Versteck-Garage). Spiegel von
 * apps/backend/src/modules/vehicle/stellplatz.service.ts::StellplatzOverview.
 */

import { api } from './api.js';

export interface StellplatzSlotView {
  slotIndex: number;
  vehicleId: string | null;
  vehicleKey: string | null;
  vehicleLabel: string | null;
  context: string | null;
}

export interface StellplatzPropertyView {
  propertyId: string;
  label: string;
  subType: string;
  customName: string | null;
  nickname: string | null;
  type: 'HIDEOUT' | 'WAREHOUSE';
  slots: StellplatzSlotView[];
  freeCount: number;
}

export interface StellplatzOverview {
  properties: StellplatzPropertyView[];
  homeless: { vehicleId: string; vehicleKey: string; vehicleLabel: string; context: string }[];
  totalSlots: number;
  vehiclesRequiringSlots: number;
  purchasableCount: number;
}

export async function fetchStellplaetze(): Promise<StellplatzOverview> {
  return api.get<StellplatzOverview>('/vehicle/stellplaetze');
}

export async function moveVehicleToStellplatz(vehicleId: string, propertyId: string, slotIndex?: number): Promise<void> {
  await api.post<unknown>(`/vehicle/${encodeURIComponent(vehicleId)}/stellplatz`, {
    propertyId,
    ...(slotIndex !== undefined ? { slotIndex } : {}),
  });
}

/** "DHL-Transporter (Dealer Sven an der Bushaltestelle), …" — was die Plätze einer Immobilie belegt. */
export function describeOccupants(p: StellplatzPropertyView): string {
  return p.slots
    .filter((s) => s.vehicleId !== null)
    .map((s) => `${s.vehicleLabel ?? ''} (${s.context ?? ''})`)
    .join(', ');
}
